<template>
    <div>
        <div class="table-wrapper on-991" v-if="$i18n.locale=='en'">
            <div>
                <table>
                    <thead>
                        <tr class="dark-gray">
                            <td><span class="invisible">asd</span></td>
                            <td colspan="3" class="text-center text-white font-weight-bold">NOTIONAL AMOUNTS BY TERM TO MATURITY</td>
                        </tr>
                        <tr class="med-gray">
                            <td><span class="invisible">adsd</span></td>
                            <td class="text-right text-white font-weight-bold">POSITIVE FAIR<br/>VALUE</td>
                            <td class="text-right text-white font-weight-bold">NEGATIVE FAIR<br/>VALUE</td>
                            <td class="text-right text-white font-weight-bold">NOTIONAL<br/>AMOUNT</td>
                        </tr>
                        <tr class="light-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td colspan="3" class="text-center text-white font-weight-bold">KD ’000</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="blueColor" colspan="4">At 31 December 2020</td>
                        </tr>
                        <tr>
                            <td colspan="4">Derivatives held for hedging:</td>
                        </tr>
                        <tr>
                            <td colspan="3">
                                <div class="d-flex">
                                    <div>Cash flow hedges -</div>
                                    <div>Receive 3-month LIBOR/ SIBOR,<br/>pay fixed interest rate</div>
                                </div>
                            </td>
                            <td class="text-right">-</td>
                        </tr>
                        <tr>
                            <td>Profit rate swaps (maturing after one year)</td>
                            <td class="text-right">-</td>
                            <td class="text-right">16,699</td>
                            <td class="text-right">147,950</td>
                        </tr>
                        <tr>
                            <td class="blueColor" colspan="4">At 31 December 2019</td>
                        </tr>
                        <tr>
                            <td colspan="4">Derivatives held for hedging:</td>
                        </tr>
                        <tr>
                            <td colspan="4">
                                <div class="d-flex">
                                    <div>Cash flow hedges - </div>
                                    <div>Receive 3-month LIBOR/ SIBOR,<br/>pay fixed interest rate </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>Profit rate swaps (maturing after one year)</td>
                            <td class="text-right">-</td>
                            <td class="text-right">10,350</td>
                            <td class="text-right">241,142</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Arabic -->

        <div class="table-wrapper on-991" v-if="$i18n.locale=='ar'">
            <div>
                <table>
                    <thead>
                        <tr class="dark-gray">
                            <td><span class="invisible">asd</span></td>
                            <td colspan="3" class="text-center text-white font-weight-bold">القيم الاسمية حسب المدة حتى أجل الاستحقاق</td>
                        </tr>
                        <tr class="med-gray">
                            <td><span class="invisible">adsd</span></td>
                            <td class="text-right text-white font-weight-bold">القيمة العادلة <br/>الموجبة</td>
                            <td class="text-right text-white font-weight-bold">القيمة العادلة<br/> السالبة</td>
                            <td class="text-right text-white font-weight-bold">القيمة الاسمية</td>
                        </tr>
                        <tr class="light-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td colspan="3" class="text-center text-white font-weight-bold">ألف دينار كويتي</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="blueColor" colspan="4">31 ديسمبر 2020</td>
                        </tr>
                        <tr>
                            <td colspan="4">مشتقات محتفظ بها للتحوط:</td>
                        </tr>
                        <tr>
                            <td colspan="3">
                                <div class="d-flex">
                                    <div>تحوطات التدفق النقدي- </div>
                                    <div>استلام معدل ليبور / سيبور لـ 3 أشهر<br/>سداد معدل فائدة ثابت</div>
                                </div>
                            </td>
                            <td class="text-right">-</td>
                        </tr>
                        <tr>
                            <td>مبادلات معدلات الربح (تستحق بعد سنة واحدة)</td>
                            <td class="text-right">-</td>
                            <td class="text-right">16,699</td>
                            <td class="text-right">147,950</td>
                        </tr>
                        <tr>
                            <td class="blueColor" colspan="4">31 ديسمبر 2019</td>
                        </tr>
                        <tr>
                            <td colspan="4">مشتقات محتفظ بها للتحوط:</td>
                        </tr>
                        <tr>
                            <td colspan="4">
                                <div class="d-flex">
                                    <div>تحوطات التدفق النقدي -</div>
                                    <div>استلام معدل ليبور / سيبور لـ 3 أشهر<br/> سداد معدل فائدة ثابت</div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>مبادلات معدلات الربح (تستحق بعد سنة واحدة)</td>
                            <td class="text-right">-</td>
                            <td class="text-right">10,350</td>
                            <td class="text-right">241,142</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>